export class OxygenForm extends HTMLFormElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('submit', this.handleSubmit);
    }

    handleSubmit(event) {
        event.preventDefault(); // Prevent the default form submission

        // Capture form data
        const formData = new FormData(this);

        // Convert FormData to a simple object for easier processing
        const formObject = {};
        formData.forEach((value, key) => {
            formObject[key] = value;
        });

        console.log('Form data:', formObject);

        // You can now send this data via an AJAX request or handle it as needed
    }
}

if (!customElements.get('oxygen-form')) {
    customElements.define('oxygen-form', OxygenForm, { extends: 'form' });
}